import React from 'react'
import {useSelector} from 'react-redux'
import {PaymentMode} from '@findhotel/sapi'
import {useIsraeliVatEligibility} from 'hooks/useIsraeliVatEligibility'
import {getAccommodationPageHotelId} from 'modules/accommodation/selectors'
import {getAccommodationPageHotelCountry} from 'modules/searchApi/selectors'

import {OfferPrice} from '@vio/core/src/offer/types/offer'
import {PriceDetails} from '@vio/shared/src/booking/PriceDetails'
import {usePointsPriceDisplay} from '@vio/shared/src/whiteLabel/hooks/usePointsPriceDisplay'
import {PointsPrice} from '@vio/shared/src/whiteLabel/PointsPrice'

interface DealDetailsPriceBreakdownProps {
  prices: OfferPrice[]
  paymentMode?: PaymentMode
  checkIn: string
  checkOut: string
  numberOfGuests: number
  numberOfRooms: number
  isSplitBooking?: boolean
}

export const DealDetailsPriceBreakdown = ({
  prices,
  paymentMode,
  checkIn,
  checkOut,
  numberOfGuests,
  numberOfRooms,
  isSplitBooking = false
}: DealDetailsPriceBreakdownProps) => {
  const hotelId = useSelector(getAccommodationPageHotelId)
  const hotelCountry = useSelector(getAccommodationPageHotelCountry)

  const {isPropertyEligible, isLocalVatIncluded, hasAdditionalCharges} =
    useIsraeliVatEligibility(hotelId)
  const points = usePointsPriceDisplay()

  return (
    <PriceDetails
      checkIn={checkIn}
      checkOut={checkOut}
      numberOfGuests={numberOfGuests}
      numberOfRooms={numberOfRooms}
      paymentMode={paymentMode}
      prices={prices}
      showFeesDescriptions={false}
      hotelCountryCode={hotelCountry}
      displayNumberOfRooms={!isSplitBooking}
      hasAdditionalCharges={hasAdditionalCharges}
      showTaxesAndFeesCombined
      displayTransparentFees
      isLocalVatIncluded={isLocalVatIncluded}
      showVatDisclaimer={isPropertyEligible}
      renderTotalPrice={
        points.isOn
          ? (value, currencyCode) => (
              <PointsPrice
                {...points.splitParts(value)}
                currencyCode={currencyCode}
                showMaxPointsCaption={false}
                alignment="end"
              />
            )
          : undefined
      }
    />
  )
}
